import { clone } from 'ramda';

export const trimAllStringProperties = <T>(formSubmissionObject: T): T => {
	const trimmedFormSubmissionObject: any = clone(formSubmissionObject);

	Object.keys(trimmedFormSubmissionObject).forEach((key: string) => {
		if (typeof trimmedFormSubmissionObject[key] === 'string') {
			trimmedFormSubmissionObject[key] = trimmedFormSubmissionObject[
				key
			].trim();
		}
	});

	return trimmedFormSubmissionObject;
};
